import Widget from "csi/table/Widget";
import { QueryLevel } from "csi/view/_query/Level";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";

const AllSharedBOMsTableController = declare(Widget, {
	onCreateMainQueryLevel(ql: QueryLevel): void {
		const bomUrl = this.getSourceContext().getNodeParentURL();
		const q = new Query();
		q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, bomUrl);
		if (!q.isEmpty()) {
			ql.serverQuery = q;
		}
	},
});

export = AllSharedBOMsTableController;